// Export event types
export * from "./types";

// Export publisher
export { eventPublisher, publishEvent } from "./publisher";

// Export subscriber
export { eventSubscriber } from "./subscriber";
export type { TrackingAdapter } from "./subscriber";

// Export adapters
export * from "./adapters";

/**
 * Initialize the event tracking system with the provided adapters
 * @param adapters Array of tracking adapters to register
 */
export async function initializeEventTracking(
  adapters: import("./subscriber").TrackingAdapter[],
): Promise<void> {
  // Import the subscriber
  const { eventSubscriber } = await import("./subscriber");

  // Register each adapter using for...of instead of forEach
  for (const adapter of adapters) {
    eventSubscriber.registerAdapter(adapter);
  }

  // Initialize the subscriber
  await eventSubscriber.initialize();
}
